import { Maybe, None, Some } from "../../../../misc/option";
export class FieldContainer {
    constructor(fields) {
        this.fields = fields;
        this.selected = fields.length > 0 ? new Some(fields[0]) : None.instance();
    }
    includes(field) {
        return this.fields.includes(field);
    }
    update(fields) {
        this.fields = fields;
        if (this.selected.isSomeAnd((a) => this.includes(a))) {
            return;
        }
        this.select_first();
    }
    select(field) {
        let requested = this.fields.find(f => f === field);
        this.selected = Maybe(requested);
    }
    select_first() {
        if (this.fields.length === 0)
            return;
        this.select(this.fields[0]);
    }
    iter() {
        return this.fields;
    }
}
